import { atom, useAtom } from "jotai";
import { OrderStatus } from "../utils/enum";

type PaginationStatus =
  | OrderStatus.ARRIVED
  | OrderStatus.IN_KITCHEN
  | OrderStatus.READY_FOR_DELIVERY
  | OrderStatus.EN_ROUTE;

export type PaginationStatusProps = Record<PaginationStatus, number>;

export const defaultValues: PaginationStatusProps = {
  [OrderStatus.ARRIVED]: 0,
  [OrderStatus.IN_KITCHEN]: 0,
  [OrderStatus.READY_FOR_DELIVERY]: 0,
  [OrderStatus.EN_ROUTE]: 0,
};

const orderPageAtom = atom<PaginationStatusProps>(defaultValues);

const useOrderPage = () => {
  const atom = useAtom(orderPageAtom);
  return atom;
};

export const useSetOrderPage = () => useAtom(orderPageAtom);

export default useOrderPage;
